export const latLongFormats = [
  "Decimal Degrees",
  "Degrees Decimal Minutes",
  "Degrees Minutes Seconds",
];

// * Message to be displayed on the red banner temporarily
export const LAT_LON_DECIMAL_TITLE =
  "Minimum of four decimal places required for latitude/longitude submitted in Decimal Degrees Format";
